import React from "react";
import { ShoppingBag, Ticket, Download } from "lucide-react";

const PurchaseItem = ({ purchase }) => {
  const getIcon = () => {
    switch (purchase?.type) {
      case "Merchandise":
        return <ShoppingBag size={16} />;
      case "Event Ticket":
        return <Ticket size={16} />;
      case "Digital Product":
        return <Download size={16} />;
      default:
        return <ShoppingBag size={16} />;
    }
  };

  const itemName = purchase?.itemName || purchase?.title || "Unknown Item";
  const displayImage = purchase?.imageUrl || purchase?.thumbnailUrl;

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow flex">
      <div className="relative w-24 h-24 flex-shrink-0 bg-slate-100">
        {displayImage ? (
          <img 
            src={displayImage} 
            alt={itemName} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400">
            {getIcon()}
          </div>
        )}
      </div>
      
      <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
        <div>
          <div className="flex items-start justify-between mb-1">
            <h3 className="font-bold text-slate-800 text-sm line-clamp-1 flex-1" title={itemName}>
              {itemName}
            </h3>
            <div className="ml-2 bg-slate-100 px-2 py-0.5 rounded-md text-xs font-bold text-slate-700 flex items-center gap-1 flex-shrink-0">
              {getIcon()}
              {purchase?.type || purchase?.fileType || "Item"}
            </div>
          </div>
          <p className="text-xs text-slate-500">{purchase?.creatorName}</p>
        </div>
        
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-slate-400">{purchase?.purchaseDate}</span>
          <span className="font-bold text-primary text-sm">
            {(purchase?.priceETB || 0).toLocaleString("en-US", {
              style: "currency",
              currency: "ETB",
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PurchaseItem;
